module.exports = __webpack_public_path__ + "static/media/WarriorGirl.2ea8ae4d.jpg";